var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextBoxCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 17.5L11.875 15L12.8417 14.0333L14.1667 15.3583L17.1583 12.3667L18.125 13.5417L14.1667 17.5ZM10.6667 17.5H4.16667C3.24167 17.5 2.5 16.75 2.5 15.8333V4.16667C2.5 3.24167 3.24167 2.5 4.16667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V10.6667C16.7667 10.2417 15.9083 10 15 10L14.1667 10.0667V9.16667H5.83333V10.8333H12.2417C10.8917 11.725 10 13.2583 10 15C10 15.9083 10.2417 16.7667 10.6667 17.5ZM10 12.5H5.83333V14.1667H10V12.5ZM14.1667 5.83333H5.83333V7.5H14.1667",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextBoxCheck);
export default __webpack_public_path__ + "static/media/text-box-check.b29095ed0baa1c78dd9e319024e077df.svg";
export { ForwardRef as ReactComponent };